var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF4343",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.57 18.73l.16-4.83h-1.51l.17 4.83h1.18zm-.56 2.34c.247 0 .45-.078.61-.235.16-.157.24-.352.24-.585 0-.233-.08-.428-.24-.585-.16-.157-.363-.235-.61-.235-.253 0-.462.078-.625.235-.163.157-.245.352-.245.585 0 .233.082.428.245.585.163.157.372.235.625.235z",
    transform: "translate(-484 -576) translate(484 576)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.029 7.172c.281.17.517.405.686.686l8.468 14.113c.568.947.26 2.176-.686 2.744-.311.186-.667.285-1.03.285H7.533c-1.104 0-2-.895-2-2 0-.362.099-.718.285-1.029l8.468-14.113c.568-.947 1.797-1.254 2.744-.686zM24.468 23L15.999 8.888 7.532 23h16.936z",
    transform: "translate(-484 -576) translate(484 576)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoError);
export default __webpack_public_path__ + "static/media/ico-error.7e8d02d15e0070dc180cbe1d2f707ce3.svg";
export { ForwardRef as ReactComponent };